import { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  HeartHandshake,
  BadgeCheck,
  Banknote,
  Users,
  UserCheck,
  Settings,
  LogOut,
} from "lucide-react";
import "./Sidebar.css";
import logo from "../../assets/logo/ZakatLogo.png";
import img1 from "../../assets/images/agent (2).png";
import Menu from "./Menu";
import { storage } from "../../utils/storage";

const Sidebar = () => {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showmenu, setShowmenu] = useState(false);

  const storedUser =
    typeof window !== "undefined" ? storage.get("admin") || {} : {};
  const menuref = useRef();

  const CheckPath = (path) => location.pathname === path;

  useEffect(() => {
    const handler = (event) => {
      if (!menuref.current?.contains(event.target)) {
        // setShownotification(false);
        setShowmenu(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);
  return (
    <>
      {/* Mobile Top Bar */}
      <div className="appbar">
        <button
          className="menu-button"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          ☰
        </button>
        <div className="appbar-controls">
          <div className="profile-image">
            <span>{storedUser.fullname?.charAt(0) || "A"}</span>
          </div>
        </div>
      </div>

      <aside className={`sidebar ${mobileOpen ? "open" : ""}`}>
        {/* Logo */}
        <div className="sidebar-logo">
          <img src={logo} alt="logo" />
          <h3>Zakat Admin</h3>
        </div>

        {/* Menu */}
        <ul className="sidebar-list">
          {/* Dashboard */}
          <li className={CheckPath("/dashboard") ? "selected" : ""}>
            <Link to="/dashboard">
              <LayoutDashboard />
              <span>Dashboard</span>
            </Link>
          </li>

          {/* Cause Management */}
          <p className="menu-title">Cause Management</p>

          <li className={CheckPath("/allcauses") ? "selected" : ""}>
            <Link to="/allcauses">
              <HeartHandshake />
              <span>All Causes</span>
            </Link>
          </li>

          <li className={CheckPath("/Publishedcause") ? "selected" : ""}>
            <Link to="/Publishedcause">
              <BadgeCheck />
              <span>Published Causes</span>
            </Link>
          </li>
          <li className={CheckPath("/finishedcause") ? "selected" : ""}>
            <Link to="/finishedcause">
              <BadgeCheck />
              <span>Completed Causes</span>
            </Link>
          </li>
          <li className={CheckPath("/reordercause") ? "selected" : ""}>
            <Link to="/reordercause">
              <BadgeCheck />
              <span>Reorder Causes</span>
            </Link>
          </li>

          {/* Donation 
          <p className="menu-title">Donations</p>

          <li className={CheckPath("/donationlist") ? "selected" : ""}>
            <Link to="/donationlist">
              <Banknote />
              <span>Donation List</span>
            </Link>
          </li>

          <li className={CheckPath("/fundtransfers") ? "selected" : ""}>
            <Link to="/fundtransfers">
              <BadgeCheck />
              <span>Fund Transfer</span>
            </Link>
          </li>*/}

          {/* Users */}
          <p className="menu-title">Users</p>

          <li className={CheckPath("/users") ? "selected" : ""}>
            <Link to="/users">
              <Users />
              <span>Users List</span>
            </Link>
          </li>

          {/* <li className={CheckPath("/volunteers") ? "selected" : ""}>
            <Link to="/volunteers">
              <UserCheck />
              <span>Volunteers</span>
            </Link>
          </li> */}

          <li className={CheckPath("/pendingvolunteers") ? "selected" : ""}>
            <Link to="/pendingvolunteers">
              <UserCheck />
              <span>Pending Volunteers</span>
            </Link>
          </li>

          {/* Website */}
          {/*<p className="menu-title">Website</p>

         <li className={CheckPath("/banner") ? "selected" : ""}>
            <Link to="/banner">
              <Image />
              <span>Banner Management</span>
            </Link>
          </li> */}

          {/* Analytics */}
          {/* <p className="menu-title">Reports</p>

          <li className={CheckPath("/analytics") ? "selected" : ""}>
            <Link to="/analytics">
              <BarChart3 />
              <span>Analytics</span>
            </Link>
          </li> */}

          {/* Settings */}
          <p className="menu-title">Settings</p>

          <li className={CheckPath("/setting") ? "selected" : ""}>
            <Link to="/setting">
              <Settings />
              <span>Settings</span>
            </Link>
          </li>

          <li>
            <Link to="/logout">
              <LogOut />
              <span>Logout</span>
            </Link>
          </li>
        </ul>
      </aside>
      <div ref={menuref}>{showmenu && <Menu showmenu={setShowmenu} />}</div>
    </>
  );
};

export default Sidebar;
